import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28d82594"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "postback__help" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "{sub1} - Sub ID 1", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "{sub2} - Sub ID 2", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "{sub3} - Sub ID 3", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "{sub4} - Sub ID 4", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "{sub5} - Sub ID 5", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "{sub6} - Sub ID 6", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "{sub7} - Sub ID 7", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('postback_setting_info')), 1),
    _hoisted_2,
    _createElementVNode("p", null, [
      _createElementVNode("b", null, _toDisplayString(_ctx.$t('params')), 1)
    ]),
    _hoisted_3,
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('params')) + ":", 1),
    _createElementVNode("p", null, "{event} - " + _toDisplayString(_ctx.$t('event_type')), 1),
    _createElementVNode("p", null, "{payout} - " + _toDisplayString(_ctx.$t('amount_sum')), 1),
    _createElementVNode("p", null, "{currency} - " + _toDisplayString(_ctx.$t('amount_currency')), 1),
    _createElementVNode("p", null, "{revshare_payout} - " + _toDisplayString(_ctx.$t('general_income_revshare')), 1),
    _createElementVNode("p", null, "{campaign_id} - " + _toDisplayString(_ctx.$t('id_campaign')), 1),
    _createElementVNode("p", null, "{conversion_id} - " + _toDisplayString(_ctx.$t('conversion_id')), 1),
    _createElementVNode("p", null, "{offer_id} - " + _toDisplayString(_ctx.$t('id_offer')), 1),
    _createElementVNode("p", null, "{offer_name} - " + _toDisplayString(_ctx.$t('offer_name')), 1),
    _createElementVNode("p", null, "{status} - " + _toDisplayString(_ctx.$t('all_status')), 1),
    _createElementVNode("p", null, "{deposit_id} - " + _toDisplayString(_ctx.$t('deposit_id')), 1),
    _createElementVNode("p", null, "{datetime} - " + _toDisplayString(_ctx.$t('unix_timestamp')), 1),
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _hoisted_10
  ]))
}